import * as environment from '../../../config/environment';

import { BaseAPI } from "../../BaseAPI";

class CtvKullanimListeAPI extends BaseAPI {
  

  constructor () {
    const baseUrl = environment.API_URL + "CtvKullanimListe";
    super(baseUrl);
  }


  getCtvKullanimListe( ctvKullanimSekliKodu?: number){
    var request= new CtvKullanimListeRequest( ctvKullanimSekliKodu);
    
    return this.get("",request);
  }

}


export default new CtvKullanimListeAPI();
class CtvKullanimListeRequest {
  public ctvKullanimSekliKodu?: number;

 
  constructor(ctvKullanimSekliKodu?: number) {
   
      this.ctvKullanimSekliKodu = ctvKullanimSekliKodu;

      
  }
}
export { CtvKullanimListeRequest };